<Loader :loading="loading" />
<HomeNavBar />
<InactivityModal />

<div class="mx-auto ">
    <!-- Filters & Search -->
    <!-- Event List -->
    <div class="row">
        <div class="col-lg-2 d-none d-lg-block h-100">
            <MenuSideBar />
        </div>
        <div class="col-lg-10 col-md-12 col-12 ">
            <h2 class="fw-bold text-center text-uppercase mt-2">
                <span class="fw-bolder">Businesses</span>
            </h2>
            <div class="card shadow-sm border-0 me-5 rounded-5 ms-3 full-width-mobile">
                <div
                    class="card-header bg-white d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center py-3 rounded-5">
                    <div class="d-flex flex-row align-items-center gap-4 my-0 w-100">
                         <!-- Filtering label -->
                        <strong class="text-muted me-2 d-none d-sm-block">Filtering:</strong>
                        <input type="text" v-model="businessSearch" placeholder="Search..." class="form-control form-control-sm text-xxs rounded-pill shadow" />
                    </div>
                </div>


            </div>
            <div class="row mt-3overflow-auto p-3 full-width-mobile scroll-container mt-2">
                <div v-for="business in filteredBusinesses" :key="business.id" class="col-sm-6 col-md-4 col-lg-4 mb-4">
                    <div class="profile-card mb-3 shadow-sm cursor-pointer me-4 h-100" @click="view_profile(business)">
                        <div class="card-top bg-primary p-4 position-relative text-center">
                            <img src="@/assets/images/business-briefcase.jpg" class="avatar" alt="User">
                            <span class="position-absolute top-0 end-0 m-2 badge bg-warning text-white shadow-sm rounded-pill">
                                {{ business.rating || 0 }}
                            </span>
                        </div>

                        <div class="stars mt-3">

                            <i v-for="star in 5" :key="star" class="bi"
                                :class="star <= business.rating ? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
                        </div>
                        <div class="card-body text-center p-3">
                            <h5 class="text-sm mb-2 text-center">{{ business.company_name }}</h5>

                            <p class="text-muted small mb-1" v-if="business.email">
                              <i class="bi bi-envelope me-1"></i><strong>Email: </strong>{{ business.email }}
                            </p>

                            <p class="text-muted small mb-2" v-if="business.location">
                              <i class="bi bi-geo-alt me-1"></i><strong>Location: </strong>{{ business.location }}
                            </p>
                        </div>

                    </div>
                </div>

                <!-- Empty State -->
                <div v-if="!filteredBusinesses.length" class="text-center text-muted py-5 w-100">
                    <i class="bx bx-building-house fs-1"></i>
                    <p class="mt-2 mb-0">No businesses found</p>
                </div>
            </div>

        </div>
    </div>
</div>
<StickyNav/>